import React from 'react';
import Grid from '@techsoftware/happay-widgets/Grid';
import AlreadLoggedIn from '@techsoftware/happay-widgets/AlreadyLoggedIn';
import ProductLogo from '../../assets/images/IPP_product_logo.svg';
import history from '../../utils/history';

export default class AlreadLoggedInComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reloginWithOTP: false,
    };
  }

  componentDidMount() {
    const { loginInfo: { value } = {} } = this.props;
    if (!value) {
      history.push('/login');
    }
  }

  onResend = () => {
    const { tempToken, onResend } = this.props;
    const param = {
      temporary_token: tempToken,
    };
    onResend(param);
  };

  onSubmit = otp => {
    const { onSubmit, tempToken } = this.props;
    const param = {
      temporary_token: tempToken,
      otp,
    };
    onSubmit(param);
  };

  render() {
    const { str = '' } = this.props;
    return (
      <Grid
        container
        justify="center"
        direction="row"
        className="happayProduct--container"
      >
        <AlreadLoggedIn
          errorText={str}
          logo={ProductLogo}
          onResend={this.onResend}
          onSubmit={this.onSubmit}
          className="signin-container"
        />
      </Grid>
    );
  }
}
